import { render } from "./GlobalSpinner.vue?vue&type=template&id=f984adce&scoped=true"
import script from "./GlobalSpinner.vue?vue&type=script&lang=js"
export * from "./GlobalSpinner.vue?vue&type=script&lang=js"

import "./GlobalSpinner.vue?vue&type=style&index=0&id=f984adce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f984adce"]])

export default __exports__